import { Injectable } from "@angular/core";
import { FormClientService } from "./communication/form-client.service";
import { SecurityService } from "../security/services/security.service";
import { FormCreate, FormDetails, FormFileInformation, FormMinimal, FormSend, FormTable } from "./model/form.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FormService {

    constructor(private formClientService: FormClientService,
                private securityService: SecurityService) {}



    createForm(formCreate: FormCreate): Observable<FormTable>{
        return this.formClientService.createForm(formCreate);
    }


    uploadFileToForm(formUUID: string, file: File): Observable<void>{
        return this.formClientService.uploadFileToForm(formUUID, file);
    }


    updateForm(formSend: FormSend, formUUID: string): Observable<void>{
        return this.formClientService.updateForm(formSend, formUUID);
    }


    updateUploadFileToForm(formUUID: string, file: File): Observable<void>{
        return this.formClientService.updateUploadFileToForm(formUUID, file)
    }


    deleteToForm(formUUID: string): Observable<void>{
        return this.formClientService.deleteToForm(formUUID);
    }


    getTableFormList(): Observable<Array<FormTable>>{
        return this.formClientService.getTableFormList();
    }


    downloadFileForm(uuidForm: string): Observable<Blob> {
        return this.formClientService.downloadFileForm(uuidForm);
    }


    getFormDetails(formUUID: string): Observable<FormDetails>{
        return this.formClientService.getFormDetails(formUUID);
    }


    checkExistenceFormID(formIdentifier: string): Observable<boolean>{
        return this.formClientService.checkExistenceFormID(formIdentifier);
    }


    checkExistenceTeamIDForUpdate(formIdentifier: string, formUUID: string): Observable<boolean>{
        return this.formClientService.checkExistenceTeamIDForUpdate(formIdentifier, formUUID);
    }


    getFormFileInformation(formUUID : string): Observable<FormFileInformation>{
        return this.formClientService.getFormFileInformation(formUUID);
    }


    getFormMinimalListOfOrganisation(): Observable<Array<FormMinimal>>{
        return this.formClientService.getFormMinimalListOfOrganisation();
    }
                
}